<div class="card">
  <div class="card-body">
    <h5>{{ 'personalData_title' | l10n }}</h5>
    <div class="infoCard-action" *ngIf="changeLink">
      &raquo; <a [routerLink]="[changeLink]">{{ 'registration_change' | l10n }}</a>
    </div>
    <div class="info-list">
      <div>
        <div class="label">{{ 'person_fullName' | l10n }}</div>
        <div>
          {{ registration.person.firstName }} {{ registration.person.lastName }}
        </div>
      </div>
      <div>
        <div class="label">{{ 'person_email' | l10n }}</div>
        <div>
          {{ registration.person.email }}
        </div>
      </div>
      <div *ngIf="registration.otEvent.organization.personHasFullBirthdate">
        <div class="label">{{ 'person_birthdate' | l10n }}</div>
        <div>
          <span>{{ registration.person.birthdate | localizedDate }}</span>
        </div>
      </div>
      <div *ngIf="! registration.otEvent.organization.personHasFullBirthdate">
          <div class="label">{{ 'person_birthdateYear' | l10n }}</div>
          <div>
            <span *ngIf="! registration.otEvent.organization.personHasFullBirthdate">{{ registration.person.birthdate | localizedDate:['yyyy'] }}</span>
          </div>
        </div>
      <div *ngIf="registration.person.telephone">
        <div class="label">{{ 'person_telephone' | l10n }}</div>
        <div>
          {{ registration.person.telephone }}
        </div>
      </div>

      <div *ngIf="registration.person.address.street || registration.person.address.city || registration.person.address.postcode || registration.person.address.countryCode">
        <div class="label">{{ 'person_address' | l10n }}</div>
        <div>
          <span *ngIf="registration.person.address.street">{{ registration.person.address.street }}<br></span>
          <span *ngIf="registration.person.address.city">{{ registration.person.address.city }}<br></span>
          <span *ngIf="registration.person.address.postcode">{{ registration.person.address.postcode }}<br></span>
          <span *ngIf="registration.person.address.country">{{ registration.person.address.country.localizedName }}<br></span>
        </div>
      </div>

      <div *ngIf="registration.notes">
        <div class="label">{{ 'registration_notes' | l10n }}</div>
        <div>
          {{ registration.notes }}
        </div>
      </div>
      <div *ngIf="registration.informationSourceAnswer">
        <div class="label">{{ 'registration_informationSourceAnswer' | l10n }}</div>
        <div>
          {{ registration.informationSourceAnswer }}
        </div>
      </div>
      <div *ngIf="registration.registrationReasonAnswers && registration.registrationReasonAnswers.length > 0">
        <div class="label">{{ 'registration_registrationReasonAnswers' | l10n }}</div>
        <div>
          <ul class="personInfo-list">
            <li *ngFor="let registrationReasonAnswer of registration.registrationReasonAnswers">
              {{ registrationReasonAnswer.answer }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
